import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import Icon from '@ant-design/icons';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/deleteIcon/deleteIcon.svg';
import ErrorBoundary from '../../ErrorBoundary';
import styles from '../EntityManager.module.scss';
const EntityListItem = observer(function ({ entity, children, entityIdKey, disabled, readOnly, onEdit, onDelete, customListActions, customActionIcons, className, isHighlighted, }) {
    const isDisabled = disabled ? disabled(entity) : false;
    const isReadOnly = readOnly ? readOnly(entity) : false;
    const actionsHidden = isDisabled || isReadOnly;
    const handleItemClick = () => {
        if (typeof onEdit === 'function' && !isDisabled) {
            onEdit(entity);
        }
    };
    return (React.createElement(ErrorBoundary, { key: entity[entityIdKey] },
        React.createElement("li", { className: classNames(styles.entityListItem, className, {
                [styles.disabled]: isDisabled || isReadOnly,
                [styles.clickable]: typeof onEdit === 'function' && !isDisabled,
                [styles.highlightedItem]: isHighlighted,
            }), onClick: handleItemClick },
            children,
            React.createElement("div", { className: styles.entityListItemActions },
                !actionsHidden && customListActions && customListActions(entity),
                typeof onDelete === 'function' && !actionsHidden && (React.createElement(Icon, { className: classNames(styles.entityListItemBtn, styles.entityListItemDeleteBtn), component: (customActionIcons === null || customActionIcons === void 0 ? void 0 : customActionIcons.delete) || DeleteIcon, onClick: (e) => {
                        e.stopPropagation();
                        if (!actionsHidden && onDelete) {
                            onDelete(entity);
                        }
                    } }))))));
});
export default EntityListItem;
